function hideAll() {
	let collapsingElements = document.getElementsByClassName("collapsible");
	let contentElements = document.getElementsByClassName("content");
	Array.from(contentElements).forEach((e) => (e.style.display = "none"));
	Array.from(collapsingElements).forEach((e) => e.classList.remove("active"));
}
